/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as axios from 'axios';
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CreateOpportunityDto,
  CreateOpportunityFromTemplateDto,
  GetOpportunityClaimsParams,
  GetOpportunitySharesParams,
  InviteTalentMembersDto,
  ListOpportunitiesParams,
  OpportunityClaimDtoPaginatedResult,
  OpportunityDto,
  OpportunityDtoPaginatedResult,
  OpportunityShareDtoPaginatedResult,
  OpportunityStatsDto,
  PatchOpportunityDto,
  RemoveSharesDto,
  UpdateOpportunityDto
} from '.././types';




  /**
 * **Required Permission(s):** ORG_OPP_LIST
 */
export const listOpportunities = <TData = AxiosResponse<OpportunityDtoPaginatedResult>>(
    params?: ListOpportunitiesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/opportunities`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_CREATE
 */
export const createOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    createOpportunityDto: CreateOpportunityDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/opportunities`,
      createOpportunityDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_GET
 */
export const getOpportunityById = <TData = AxiosResponse<OpportunityDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/opportunities/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_UPDATE
 */
export const updateOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string,
    updateOpportunityDto: UpdateOpportunityDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.put(
      `/api/opportunities/${id}`,
      updateOpportunityDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_UPDATE
 */
export const patchOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string,
    patchOpportunityDto: PatchOpportunityDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.patch(
      `/api/opportunities/${id}`,
      patchOpportunityDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_DELETE
 */
export const deleteOpportunity = <TData = AxiosResponse<void>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.delete(
      `/api/opportunities/${id}`,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_CREATE
 */
export const createOpportunityFromTemplate = <TData = AxiosResponse<OpportunityDto>>(
    createOpportunityFromTemplateDto: CreateOpportunityFromTemplateDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/opportunities/from-template`,
      createOpportunityFromTemplateDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_PUBLISH
 */
export const shareOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/opportunities/${id}/share`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_CLOSE
 */
export const closeOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/opportunities/${id}/close`,undefined,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_SHARE
 */
export const inviteToOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string,
    inviteTalentMembersDto: InviteTalentMembersDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.post(
      `/api/opportunities/${id}/invite`,
      inviteTalentMembersDto,options
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_SHARE
 */
export const removeFromOpportunity = <TData = AxiosResponse<OpportunityDto>>(
    id: string,
    removeSharesDto: RemoveSharesDto, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.delete(
      `/api/opportunities/${id}/invite`,{data:
      removeSharesDto, ...options}
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_GET
 */
export const getOpportunityShares = <TData = AxiosResponse<OpportunityShareDtoPaginatedResult>>(
    id: string,
    params?: GetOpportunitySharesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/opportunities/${id}/shares`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
/**
 * **Required Permission(s):** ORG_OPP_LIST
 */
export const getOpportunityStats = <TData = AxiosResponse<OpportunityStatsDto>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/opportunities/stats`,options
    );
  }
/**
 * **Required Permission(s):** ORG_CLAIM_LIST
 */
export const getOpportunityClaims = <TData = AxiosResponse<OpportunityClaimDtoPaginatedResult>>(
    id: string,
    params?: GetOpportunityClaimsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.default.get(
      `/api/opportunities/${id}/claims`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }
export type ListOpportunitiesResult = AxiosResponse<OpportunityDtoPaginatedResult>
export type CreateOpportunityResult = AxiosResponse<OpportunityDto>
export type GetOpportunityByIdResult = AxiosResponse<OpportunityDto>
export type UpdateOpportunityResult = AxiosResponse<OpportunityDto>
export type PatchOpportunityResult = AxiosResponse<OpportunityDto>
export type DeleteOpportunityResult = AxiosResponse<void>
export type CreateOpportunityFromTemplateResult = AxiosResponse<OpportunityDto>
export type ShareOpportunityResult = AxiosResponse<OpportunityDto>
export type CloseOpportunityResult = AxiosResponse<OpportunityDto>
export type InviteToOpportunityResult = AxiosResponse<OpportunityDto>
export type RemoveFromOpportunityResult = AxiosResponse<OpportunityDto>
export type GetOpportunitySharesResult = AxiosResponse<OpportunityShareDtoPaginatedResult>
export type GetOpportunityStatsResult = AxiosResponse<OpportunityStatsDto>
export type GetOpportunityClaimsResult = AxiosResponse<OpportunityClaimDtoPaginatedResult>
